import { store } from '@/store/store';
import { producto } from '@/shared/dtos/producto';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';
import ocultarcamposModule from './ocultarcampos-module';
import { ProcessoNums } from '@/views/procesos/ProcessoNums';
import { cajasDto } from '@/shared/dtos/cajasDto';

@Module({
    namespaced: true,
    name: 'productoModule',
    store,
    dynamic: true
})
class productoModule extends VuexModule {
    public productos: producto[] = [];
    public producto: producto = new producto();
    public cajas:cajasDto[] = [];

    @Action({ commit: 'onGetproductos' })
    public async getproductos() {
        return await ssmHttpService.get(API.producto);
    }

    @Action({ commit: 'onGetproductos' })
    public async getproductos_caja(localizacion: string) {
        return await ssmHttpService.get(API.producto + '/cajas/false/' + localizacion);
    }
    @Action({ commit: 'onGetcajas' })
    public async getcajas() {
        return await ssmHttpService.get(API.producto + '/cajas/true/');
    }
    @Action({ commit: 'onGetproducto' })
    public async getproducto(id: any) {
        return await ssmHttpService.get(API.producto + '/' + id);
    }

    @Action
    public async guardarproducto(producto: producto) {
        return await ssmHttpService.post(API.producto, producto.toJson());
    }

    @Action
    public async modificarproducto(producto: producto) {
        return await ssmHttpService.put(API.producto + '/' + producto.id, producto);
    }

    @Action
    public async venderproducto(producto: producto) {
        return await ssmHttpService.put(API.producto + '/vender/' + producto.id, producto);
    }

    @Action
    public async venderVenta(payload: { ventaId: number; metodo_pago: number }) {
        return await ssmHttpService.post(
            API.productosVenderVenta + payload.ventaId,
            { metodo_pago: payload.metodo_pago }
        );
    }

    @Action
    public async eliminarproducto(producto: producto) {
        return await ssmHttpService.delete(API.producto + '/' + producto.id, null, false);
    }

    @Action
    public async extraerAmazon() {
        return await ssmHttpService.get(API.producto + '/extraer-amazon');
    }

    @Action
    public async extraerDatosAmazon(asin: string) {
        return await ssmHttpService.get(API.producto + '/extraer-datos/' + asin);
    }

    @Action
    public async extraerAmazonProceso() {
        return await ssmHttpService.get(API.producto + '/extraer-proceso-amazon', null, false);
    }
    @Action
    public async extraerAmazonPrecios() {
        return await ssmHttpService.get(API.producto + '/extraer-amazon-precios');
    }

    @Action
    public async extraerAmazonProcesoPrecios() {
        return await ssmHttpService.get(API.producto + '/extraer-proceso-amazon-precios', null, false);
    }

    @Action
    public async getDatosAsin(asin: string) {
        return await ssmHttpService.get(API.producto + '/extraer-amazon/' + asin);
    }
    @Action
    public async crearImagen(localizacion: string) {
        return await ssmHttpService.get(API.producto + '/generar-imagen/' + localizacion);
    }

    @Mutation
    public onGetproductos(res: producto[]) {
        this.productos = res ? res.map((x) => new producto(x)) : [];
        if (this.productos.length > 0) {
            if (ocultarcamposModule.Ocultar_tarjeta_efectivo) {
                this.productos = this.productos.filter(x => x.estado !== ProcessoNums.VendidoEfectivo);
            }
        }
    }

    @Mutation
    public onGetcajas(res: cajasDto[]) {
        this.cajas = res ? res.map((x) => new cajasDto(x)) : [];
    }
    @Mutation
    public onGetproducto(res: producto) {
        this.producto = new producto(res);
    }

}
export default getModule(productoModule);